module.exports = __webpack_public_path__ + "static/assets/c30d6a0e73cf38ad6ea7f5e4fe0428a3.png";